module.exports = __webpack_public_path__ + "img/burundi.109f61d6.svg";